define([
    "angular",
    "../nlgBasket/nlgBasket"
], function (angular) {
    "use strict";

    return angular.module("nlgSelectionModule", ["nlgBasketModule"]);
});
